module.exports = __webpack_public_path__ + "static/media/welcome_ DYXES.68aa3515.png";